var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickUpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 6.66694H17.5C18.4205 6.66694 19.1666 7.41313 19.1666 8.33358V10.0872C19.1666 10.3049 19.124 10.5205 19.0411 10.7218L16.4625 16.9842C16.3339 17.2965 16.0296 17.5002 15.6919 17.5002H1.66665C1.20641 17.5002 0.833313 17.1272 0.833313 16.6669V8.33358C0.833313 7.87337 1.20641 7.50027 1.66665 7.50027H4.56818C4.83895 7.50027 5.09284 7.36872 5.24899 7.14751L9.79348 0.709461C9.91223 0.541237 10.1361 0.48498 10.3202 0.577068L11.832 1.33292C12.7083 1.77112 13.1609 2.76077 12.9192 3.71029L12.1665 6.66694ZM5.83331 8.82317V15.8336H15.1338L17.5 10.0872V8.33358H12.1665C11.0792 8.33358 10.2831 7.3094 10.5513 6.25576L11.3041 3.29912C11.3524 3.10921 11.2619 2.91127 11.0866 2.82364L10.5356 2.54817L6.6106 8.10865C6.40235 8.40367 6.13615 8.6455 5.83331 8.82317ZM4.16665 9.16692H2.49998V15.8336H4.16665V9.16692Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickUpWhite);
export default __webpack_public_path__ + "static/media/quick-up-white.d1b9d3992d8b562f07376b1b25a55d02.svg";
export { ForwardRef as ReactComponent };